import { DatabaseRecord } from "../repos/table.repo";

interface WaterSupplySuspensionLevelModelExt {
    wardName?: string;
    tollAreaName?: string
}

export interface WaterSupplySuspensionLevelModel extends DatabaseRecord, WaterSupplySuspensionLevelModelExt {
    waterFactoryId: string;
    waterSupplySuspensionId: string;
    wardId: string;
    tollAreaId: string;
    startTime?: Date;
    endTime?: Date;
}

export class WaterSupplySuspensionLevelModelFactory {
    static getEmpty(waterSupplySuspensionId: string = ""): WaterSupplySuspensionLevelModel {
        return {
            id: "",
            waterFactoryId: "",
            waterSupplySuspensionId,
            wardId: "",
            tollAreaId: "",
            startTime: new Date(),
            endTime: new Date()
        };
    }
}
